/**
 * @namespace {BX.UI}
 */
export default class ButtonState
{
	static HOVER = 'ui-btn-hover';
	static ACTIVE = 'ui-btn-active';
	static DISABLED = 'ui-btn-disabled';
	static CLOCKING = 'ui-btn-clock';
	static WAITING = 'ui-btn-wait';
	static AI_WAITING = 'ui-btn-ai-waiting';
}